import React from 'react';
import { Form } from 'antd';
import { isValidCustomEncryption, isValidCIDR, isValidIP, isValidMask, isValidVlanID, validateExcludedIP } from '../../../../Validation';

const { Item } = Form;

export const getInputRules = (fieldName, rules = []) => {

    const defaultPattern = /^[^{}\/\\,]*$/; // curly braces, commas, and slashes
    const hasRequired = rules?.some(rule => rule?.required === true);

    switch (fieldName){
            // AAP
        case 'customEncryption':
            return [
                { required: true, message: 'Encryption is required'},
                { validator: isValidCustomEncryption },
            ]
        // VLAN
        case 'CIDR':
            return [
                { validator: isValidCIDR },
                { validator: validateExcludedIP },
                { required: true, message: 'CIDR is required'}
            ]
        case 'localip':
            return [
                { validator: isValidIP },
                { validator: validateExcludedIP },
                { required: true, message: 'Local IP is required'}
            ]
        case 'vlanID':
            return [
                { validator: isValidVlanID },
                { required: true, message: 'VLAN ID is required' },
            ];
        case 'tag':
            return [
                { pattern: /^[0-9A-Z]*$/, message: 'Only capital letters (A-Z) and digits (0-9) are allowed' }, 
                { required: true, message: 'VLAN Tag is required' },
            ]
        // SNS
        case 'wan1IP':
        case 'wan2IP':
            return hasRequired ? [
                { validator: isValidIP },
                { validator: validateExcludedIP },
            ] : [];
        case 'wan1Mask':
        case 'wan2Mask':
            return hasRequired ? [
                { validator: isValidMask },
            ] : [];
        case 'wan1GatewayIP':
        case 'wan2GatewayIP':
        // case 'wan1DNSResolver1':
        // case 'wan1DNSResolver2':
        // case 'wan2DNSResolver1':
        // case 'wan2DNSResolver2':
            return hasRequired ? [
                { validator: isValidIP }
            ] : [];
        // In-Dispenser Switches
        case 'vlanTags':
            return [
                { pattern: /^[^{}\\/]*$/, message: 'Curly braces and slashes are not allowed.' }, 
            ];
        // All Devices
        case 'newSerialNum':
            return [
                { pattern: /^[0-9a-zA-Z].{5,30}$/, message: "Serial number must be 6-30 alphanumeric characters. No symbols allowed." },
            ];
        case 'comment':
            return [{}]; // no rules
        default: 
            return [
                { pattern: defaultPattern, message: "Invalid characters: { }  / \\ ,", }
            ];
        }
    }

export const DeviceRestrictedInput = ({rules, ...props}) => {

    const getItemProps = (fieldName) => {
        switch (fieldName){
            // case 'tag':
            //     return {
            //         onInput: (e) => e.target.value = e.target.value.toUpperCase()
            //     }
            default: 
                return undefined
        }
    }

    return (
        <>
            <Item rules={[...getInputRules(props.name, rules), ...rules]} {...getItemProps(props.name)} {...props}> 
                {props?.children}
            </Item>
        </>
    )
}

DeviceRestrictedInput.defaultProps = {
    rules: [{}],
}